import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { activeClass: String }
  static targets = ["link"]

  connect() {
    this.activeFrame = null;
  }

  linkClicked(event) {
    const clickedLink = event.currentTarget;
    this.setActiveLink(clickedLink);
  }

  setActiveLink(link) {
    const allLinks = this.linkTargets.length > 0
      ? this.linkTargets
      : this.element.querySelectorAll('a[data-action*="current-link#linkClicked"]');

    allLinks.forEach(l => {
      l.classList.remove(this.activeClassValue || 'active-link');
    });

    link.classList.add(this.activeClassValue || 'active-link');
    this.activeFrame = link;
  }
}
